import React from 'react';
import PropTypes from 'prop-types';
import { Route, Link } from 'react-router-dom';

// Styles
import styles from './breadcrumb.scss';

const Breadcrumb = ({
  items,
}) => (
  <nav
    className={styles.breadcrumb}
    aria-label="breadcrumb"
  >
    <ol>
      {items.map(({ label, destination }) => (
        <li
          className={styles.listItem}
          key={label}
        >
          <Link
            to={destination}
            className={styles.link}
          >
            {label}
          </Link>
        </li>
      ))}
      <Route
        path="/:category/indicator/:indicatorName/table/:state/counties"
        render={({ match }) => (
          <li className={styles.listItem}>
            <span
              className={styles.state}
            >
              {match.params.state}
            </span>
          </li>)}
      />
    </ol>
  </nav>
);

Breadcrumb.defaultProps = {
  items: [],
};

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    destination: PropTypes.string.isRequired,
  })),
};

export default Breadcrumb;



// WEBPACK FOOTER //
// ./app/components/breadcrumb/index.js